import PropTypes from "prop-types";
import React from "react";
import { findDOMNode } from "react-dom";

import { PropTypeShapes } from "../../types";
import { withContainerContext } from "../container/ContainerContext";
import { withDragAndDrop } from "./DragAndDropContext";

// HOC to automatically track the lifecycle of Drop Targets.
// Passes in the received callbacks
export function asDropTarget(WrappedComponent, viewType) {
  let returnComponent = null;

  //#!if readonly !== true
// 
// class DroppableComponent extends React.PureComponent {
// constructor(props) {
// super(props);
// this.getDragMultipleItemIds = this.getDragMultipleItemIds.bind(this);
// this.getDragStartParams = this.getDragStartParams.bind(this);
// this.onEnter = this.onEnter.bind(this);
// this.onHover = this.onHover.bind(this);
// this.onDrop = this.onDrop.bind(this);
// this.onLeave = this.onLeave.bind(this);
// this.containsPoint = this.containsPoint.bind(this);
// this.showCountOnPreview = this.showCountOnPreview.bind(this);
// this.getDropPreviewForItem = this.getDropPreviewForItem.bind(this);
// this.registerDropTarget = this.registerDropTarget.bind(this);
// }
// 
// componentWillUnmount() {
// this.props.dragAndDropRegistration.unregisterDropTarget(this._dropTarget.viewId);
// }
// 
// registerDropTarget(component, cb) {
// this.callbacks = cb;
// 
// const node = findDOMNode(component);
// 
// this._dropTarget = {
// viewType,
// component,
// node,
// zIndex: this.props.dropZIndex ? this.props.dropZIndex : 0,
// viewId: this.props.viewId,
// onEnter: this.onEnter,
// onHover: this.onHover,
// onDrop: this.onDrop,
// onLeave: this.onLeave,
// containsPoint: this.containsPoint,
// getDragMultipleItemIds: this.getDragMultipleItemIds,
// getDropPreviewForItem: this.getDropPreviewForItem,
// getDragStartParams: this.getDragStartParams,
// showCountOnPreview: this.showCountOnPreview
// };
// this.props.dragAndDropRegistration.registerDropTarget(this._dropTarget);
// }
// 
// getDragMultipleItemIds(dragItem) {
// if (this.callbacks.getDragMultipleItemIds) {
// return this.callbacks.getDragMultipleItemIds(this.props, dragItem, this._dropTarget);
// }
// return [dragItem.itemId];
// }
// 
// getDragStartParams(dragItem, positions) {
// if (this.callbacks.getDragStartParams) {
// return this.callbacks.getDragStartParams(this.props, dragItem, positions, this._dropTarget);
// }
// return {};
// }
// 
// getDropPreviewForItem(dragItem) {
// if (this.callbacks.getDropPreviewForItem) {
// return this.callbacks.getDropPreviewForItem(this.props, dragItem, this._dropTarget);
// }
// return null;
// }
// 
// showCountOnPreview(dragItem) {
// if (this.callbacks.showCountOnPreview) {
// return this.callbacks.showCountOnPreview(this.props, dragItem, this._dropTarget);
// }
// return true;
// }
// 
// containsPoint(pos) {
// const r = this.props.containerRect;
// return pos.x >= r.left && pos.x <= r.right && pos.y >= r.top && pos.y <= r.bottom;
// }
// 
// onEnter(dragItem) {
// if (this.callbacks.onEnter) {
// this.callbacks.onEnter(this.props, dragItem, this._dropTarget);
// }
// }
// 
// onLeave(dragItem) {
// if (this.callbacks.onLeave) {
// this.callbacks.onLeave(this.props, dragItem, this._dropTarget);
// }
// }
// 
// onHover(dragItem, positions) {
// if (this.callbacks.onHover) {
// return this.callbacks.onHover(this.props, dragItem, positions, this._dropTarget);
// }
// return null;
// }
// 
// onDrop(dragItem, positions) {
// if (this.callbacks.onDrop) {
// this.callbacks.onDrop(this.props, dragItem, positions, this._dropTarget);
// }
// }
// 
// render() {
      // ... and renders the wrapped component with the fresh data!
      // Notice that we pass through any additional props
// return <WrappedComponent registerDropTarget={this.registerDropTarget} {...this.props} />;
// }
// }
// 
// DroppableComponent.propTypes = {
// dragAndDropRegistration: PropTypeShapes.dragAndDropRegistration.isRequired,
// viewId: PropTypes.string.isRequired,
// dropZIndex: PropTypes.number,
// 
    // From withContainerContext
// containerRect: PropTypeShapes.flatRect.isRequired
// };
// 
// returnComponent = withDragAndDrop(withContainerContext(DroppableComponent));
// 
  //#!else

  const fakeRegisterDropTarget = () => {};
  // eslint-disable-next-line react/display-name
  returnComponent = props => <WrappedComponent registerDropTarget={fakeRegisterDropTarget} {...props} />;

  //#!endif

  return returnComponent;
}
